import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Page, { PageActionsType } from "components/common/page/Page";
import AdditionalChargesTemplateDatalist, { BOOKING_ADDITIONAL_CHARGES_TEMPLATE_DATALIST_FORM } from "components/entities/accommodation/additional-charges/templates/AdditionalChargesTemplateDatalist";
import { Roles } from "utilities/app-utilities";
import useAppContext from "utilities/hooks/useAppContext";

const AdditionalChargesTemplateDatalistPage = () => {
    const context = useAppContext();

    const pageActions: PageActionsType = [
        {
            name: 'add',
            title: 'button.add',
            icon: faPlus,
            link: () => context.modal.open(BOOKING_ADDITIONAL_CHARGES_TEMPLATE_DATALIST_FORM),
            hide: !context.userHasRole(Roles.ADMIN)
        }
    ];

    return (
        <Page wFull title="pages.accommodation.additionalChargesTemplate.list" actions={pageActions}>
            <AdditionalChargesTemplateDatalist name="list-page" />
        </Page>
    );
}

export default AdditionalChargesTemplateDatalistPage;
